
export const locationsListActions = {

  FETCH_LOCATIONS_FAILED: 'FETCH_LOCATIONS_FAILED',
  FETCH_LOCATIONS_SUCCESS: 'FETCH_LOCATIONS_SUCCESS',
  FETCH_LOCATIONS_PENDING: 'FETCH_LOCATIONS_PENDING',
  LOAD_LOCATIONS: 'LOAD_LOCATIONS',

  fetchLocationsFailed: error => ({
    type: locationsListActions.FETCH_LOCATIONS_FAILED,
    payload: error
  }),

  fetchLocationsSuccess: (id, {data}) => ({
    type: locationsListActions.FETCH_LOCATIONS_SUCCESS,
    payload: {
      id: id,
      items: data,
      count: data.length,
    }
  }),

  fetchLocationsPending: id => ({
    type: locationsListActions.FETCH_LOCATIONS_PENDING,
    payload: {
      id
    }
  }),

  loadLocations: (provinceId, sessionId) => ({
    type: locationsListActions.LOAD_LOCATIONS,
    payload: {
      id: provinceId,
      sessionId
    }
  }),
}

export const locationsListRequestActions = {
  failed: locationsListActions.fetchLocationsFailed,
  success: locationsListActions.fetchLocationsSuccess,
  pending: locationsListActions.fetchLocationsPending
};
